import { cloneDeep, find, isEqual, reject } from "lodash";
import { isInnerClauseFromField } from "./getter";
import { Clause, InnerClause } from "./model";

function setClause(clause: Clause, existingClause: Clause["and"]) {
  if (clause && clause.and) {
    return cloneDeep(clause.and);
  } else {
    return existingClause;
  }
}

export class ClauseBuilder {
  clauses: Clause["and"] = [];
  constructor(clause?: Clause) {
    this.clauses = setClause(clause, this.clauses);
  }
  setClause(clause: Clause) {
    this.clauses = setClause(clause, this.clauses);
  }
  merge(nextClause: Clause) {
    if (nextClause) {
      this.clauses = [...this.clauses, ...nextClause.and];
    }
  }
  toClause(): Clause {
    return {
      and: this.clauses,
    };
  }
  removeField(field: string) {
    this.clauses = reject(this.clauses, (innerClause) => {
      return isInnerClauseFromField(innerClause, field);
    });
  }
  addInnerClause(clause: InnerClause) {
    this.clauses.push(clause);
  }
  removeClause(clause: Clause) {
    if (clause) {
      this.clauses = reject(this.clauses, (innerClause) => {
        return !!find(clause.and, (_innerClause) => {
          return isEqual(_innerClause, innerClause);
        });
      });
    }
  }
  static create(clause?: Clause) {
    return new ClauseBuilder(clause);
  }
}
